import React, { useCallback, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Box, Typography, IconButton, Button } from '@material-ui/core';
// import { ArrowLeft, ArrowRight } from '@material-ui/icons';
import clsx from 'clsx';

import moment, { Moment } from 'moment';
import { toast } from 'react-toastify';
import useStyles from './style';
import BarberShopTitle from '../../components/BarberShopTitle';
import { useGetCompanyDetail } from '../../hooks/data/companies';
import { useGetAppointments } from '../../hooks/data/schedules';
import { useOrder } from '../../hooks/order';
import { ITimeBoxDTO } from '../../shared/interfaces/schedule-interfaces';
import { daysOfWeek } from '../../utils/constants';

type IParams = {
  slug: string;
};

const AppointmentPage: React.FC = () => {
  const classes = useStyles();
  const params = useParams<IParams>();
  const history = useHistory();

  const { orderData, updateOrderData } = useOrder();

  const [selectedDay, setSelectedDay] = useState(moment());
  const [selectedTime, setSelectedTime] = useState<ITimeBoxDTO | undefined>();

  const { data: companyData, status: companyDataStatus } = useGetCompanyDetail(
    params.slug,
  );

  const { data: timeBoxData, status: timeBoxStatus } = useGetAppointments({
    date: selectedDay.format('DD-MM-yyyy'),
    service_id: String(orderData.service.id),
  });

  const [days, setDays] = useState([
    moment(),
    moment().add(1, 'days'),
    moment().add(2, 'days'),
  ]);

  const handleClickDay = useCallback(
    (day: Moment) => () => {
      setSelectedDay(day);
      setSelectedTime(undefined);
    },
    [],
  );

  const handleClickTime = useCallback(
    (timeBox: ITimeBoxDTO) => () => {
      setSelectedTime(timeBox);
    },
    [],
  );

  const handleSubmit = useCallback(() => {
    if (!selectedTime?.start) {
      toast.error('Selecione um horário para prosseguir');
      return;
    }
    updateOrderData({
      day: selectedDay,
      startTime: selectedTime.start,
      endTime: selectedTime.end,
    });
    history.push(`/parceiro/${params.slug}/confirmacao`);
  }, [history, params.slug, selectedDay, selectedTime, updateOrderData]);

  const isPastTime = (timeBox: ITimeBoxDTO) => {
    if (moment().isBefore(selectedDay)) return false;

    const isStartHourBeforeNow =
      Number(timeBox.start.split(':')[0]) < moment().hours();
    const isEndHourBeforeNow =
      Number(timeBox.end.split(':')[0]) < moment().hours();
    const isStartHourAndMinutesBeforeNow =
      Number(timeBox.start.split(':')[0]) === moment().hours() &&
      Number(timeBox.start.split(':')[1]) < moment().minutes();
    const isEndHourAndMinutesBeforeNow =
      Number(timeBox.end.split(':')[0]) === moment().hours() &&
      Number(timeBox.end.split(':')[1]) < moment().minutes();

    return (
      isStartHourBeforeNow ||
      isEndHourBeforeNow ||
      isStartHourAndMinutesBeforeNow ||
      isEndHourAndMinutesBeforeNow
    );
  };

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={3}
      maxHeight="100vh"
    >
      <Box p={3}>
        <BarberShopTitle title={companyData?.company_name ?? ''} />
        <p>Selecione o dia e horário mais apropriado para você</p>
        <Box display="flex" justifyContent="space-between" pt={2}>
          <IconButton aria-label="delete" size="small">
            {/* <ArrowLeft /> */}
          </IconButton>
          <div>
            {days.map(day => (
              <button
                type="button"
                onClick={handleClickDay(day)}
                className={clsx(
                  classes.dayButton,
                  selectedDay.format('DD/MM') === day.format('DD/MM') &&
                    classes.selected,
                )}
              >
                <Box display="flex" flexDirection="column">
                  <span>{`${day.format('DD/MM')}`}</span>
                  <span>{Object.values(daysOfWeek)[day.day()]}</span>
                </Box>
              </button>
            ))}
          </div>
          <IconButton aria-label="delete">{/* <ArrowRight /> */}</IconButton>
        </Box>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        justifyContent="flex-start"
        alignItems="center"
        p={3}
        overflow="auto"
      >
        {timeBoxData?.length === 0 && (
          <Typography align="left">
            Não há horários disponíveis para a data selecionada.
          </Typography>
        )}
        {timeBoxStatus === 'loading' && <Typography>Carregando</Typography>}
        {timeBoxStatus === 'error' && (
          <Typography>Erro ao buscar os horários disponíveis</Typography>
        )}
        {timeBoxStatus === 'success' && timeBoxData ? (
          timeBoxData.map((timeBox, index) => (
            <button
              type="button"
              onClick={handleClickTime(timeBox)}
              className={clsx(
                classes.timeButton,
                selectedTime?.start === timeBox.start && classes.selected,
                (!timeBox.available || isPastTime(timeBox)) && classes.disabled,
              )}
              disabled={!timeBox.available || isPastTime(timeBox)}
            >
              {`${timeBox.start} às ${timeBox.end}`}
            </button>
          ))
        ) : (
          <></>
        )}
      </Box>
      <Box
        pt={2}
        borderTop="2px solid"
        display="flex"
        justifyContent="center"
        width="100%"
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!selectedTime?.start}
        >
          Avançar
        </Button>
      </Box>
    </Box>
  );
};

export default AppointmentPage;
